import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "sgm_access_token";

export const tokenStore = {
  get: () => {
    try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
  },
  set: (t) => {
    try { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); } catch { /* noop */ }
  },
  clear: () => {
    try { localStorage.removeItem(TOKEN_KEY); } catch { /* noop */ }
  },
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token as fallback when cookies don't survive cross-site
api.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export function formatApiError(detail, fallback = "") {
  if (detail == null) return fallback || "Algo salió mal. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function describeAxiosError(err) {
  // Show whatever detail the API returned
  const detail = err?.response?.data?.detail;
  if (detail != null) return formatApiError(detail);
  // No HTTP response → network / CORS / DNS / offline
  if (!err?.response) {
    if (err?.message === "Network Error") {
      return "Error de red — verifica tu conexión o intenta recargar (Ctrl+F5).";
    }
    if (err?.code === "ECONNABORTED") return "El servidor tardó demasiado. Intenta de nuevo.";
    return err?.message || "Error de conexión.";
  }
  const status = err.response.status;
  if (status === 401) return "Credenciales inválidas.";
  if (status === 403) return "No tiene permisos para esta acción.";
  if (status === 404) return "Recurso no encontrado.";
  if (status === 429) return "Demasiados intentos. Intente en unos minutos.";
  if (status >= 500) return `Error del servidor (${status}). Intente más tarde.`;
  return `Error ${status}.`;
}
